import * as React from "react";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import { Theme } from "@mui/material";
import Props from "./index.d";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    FieldSetLayoutHorizontalSimple: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      margin: 10,
      // backgroundColor: theme.palette.background.paper
    },
  })
);

interface GFCFieldSet_FieldSetLayoutHorizontalSimple extends Props {
  children: React.ReactNode;
}

const FieldSetLayoutHorizontalSimple: React.FC<GFCFieldSet_FieldSetLayoutHorizontalSimple> = (props) => {
  const { children } = props;
  const classes = useStyles({});
  // @ts-ignore
  if (props.hidden) return null;
  return <div className={classes.FieldSetLayoutHorizontalSimple}>{children}</div>;
};
export default FieldSetLayoutHorizontalSimple;
